<template>
  <div class="question-edit-variables">
    <b-card no-body>
      <b-card-header>
        <strong>Variables</strong>
      </b-card-header>
      <draggable
        class="dragArea"
        v-model="vars"
        :list="vars"
        :options="{ handle: '.drag-element' }"
        ref="dragArea"
        @update="onUpdateDraggable"
      >
        <variable-edit-form
          v-for="v in vars"
          :key="(v.id | v.uid)"
          :initial-variable="v"
          :question="question"
          :exclusive-id="exclusiveId"
          @update-exclusive="updateExclusive"
          @add-variable-option="onCreateOption"
          @update-variable="$emit('update-variable',$event)"
          @remove-option="onRemoveOption"
          @cancel-remove-option="onCancelRemoveOption"
          @delete-variable="$emit('delete-variable', $event)"
          @set-visibility-condition="
            $emit('set-visibility-condition', v.id || v.uid, $event)
          "
          @set-response-validation-condition="
            $emit('set-response-validation-condition', v.id || v.uid, $event)
          "
        />
      </draggable>
      <b-card-footer>
        <b-button
          variant="info"
          size="sm"
          class="float-right"
          @click="$emit('add-variable')"
        >
          Add Variable
        </b-button>
      </b-card-footer>
    </b-card>
  </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import draggable from 'vuedraggable';
import VariableEditForm from '@/components/question/variable/VariableEditForm';

export default {
  name: 'questionEditVariables',
  components: {
    draggable,
    VariableEditForm,
  },
  props: {
    question: Object,
    exclusiveId: {
      default: null,
      validator: (prop) => typeof prop === 'number' || prop === null,
    },
  },
  computed: {
    vars: function () {
      return [...this.question.variables];
    },
  },
  methods: {
    updateExclusive: function (...args) {
      this.$emit('update-exclusive', ...args);
    },
    onCreateOption: function (...args) {
      this.$emit('add-variable-option', ...args);
    },
    onRemoveOption: function (...args) {
      this.$emit('remove-option', ...args);
    },
    onCancelRemoveOption: function (...args) {
      this.$emit('cancel-remove-option', ...args);
    },
    onUpdateDraggable: function () {
      const orders = this.vars.map((v) => v.id || v.uid);

      this.$emit('order-variables', orders);
    },
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
.variable-label-input {
  display: inline-block;
  width: 300px;
  font-weight: bold;
}
</style>
